import React from "react";

const AnnotationArrowLine = () => {
  return (
    <span className="icon-arrow-outline-2">
      <span className="path1"></span>
      <span className="path2"></span>
      <span className="path3"></span>
    </span>
  );
};

export default AnnotationArrowLine;
